module.exports = __webpack_public_path__ + "img/PD_2.7cd10e2b.png";